module.exports = __webpack_public_path__ + "img/dark_ic_creation_step1.6fa852e2.png";